if (!customElements.get('accordion-item')) {
    // Define the custom element only if it hasn't been defined yet
    customElements.define('accordion-item', class Accordion extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            // This method is called when the element is added to the DOM
            this.querySelector('.accordion__header').addEventListener('click', () => {
                this.classList.toggle('active');
                const content = this.querySelector('.accordion__content');

                if (this.classList.contains('active')) {
                    this.expandSection(content);
                } else {
                    this.collapseSection(content);
                }
            });
        }

        expandSection(element) {
            const sectionHeight = element.scrollHeight + 'px'; 
            element.style.maxHeight = '0px';
            element.offsetHeight; // Force repaint
            element.style.maxHeight = sectionHeight;
        }

        collapseSection(element) {
            element.style.maxHeight = element.scrollHeight + 'px'; // set current height
            element.offsetHeight; // Force repaint
            element.style.maxHeight = '0px';
        }
    });
}